import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  Input,
  NgZone,
  OnInit,
  AfterViewInit,
  OnDestroy,
  Injector,
  ApplicationRef,
  ComponentFactoryResolver,
} from '@angular/core';
import * as MAP_CONFIG from '../view-live-tracking.config';
import { GoogleMapsService } from 'src/app/shared/service/google-maps-service.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import LatLngLiteral = google.maps.LatLngLiteral;
import { SsoService } from 'src/app/core/services/sso.service';
import { live_tracking, SSE_events } from 'src/app/shared/api.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { LiveShare, VehicleInfo } from '../view-live-tracking.interface';
import { interval, Subject, Subscription, takeUntil } from 'rxjs';
import { SpinnerComponent } from 'src/app/shared/component/spinner/spinner.component';
import { CommonService } from 'src/app/shared/service/common.service';

import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { PrimecustomModule } from 'src/app/shared/primeng.custom.module';
import { ToastMessageOptions } from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';
import { ServerEventService } from 'src/app/core/services/server-event.service';
import { MapTypeViewComponent } from 'src/app/shared/component/map-type-view/map-type-view.component';

import { AuthenticationService } from '../../../../shared/service/authentication.service';
import {
  LISTS,
  LIVE_SHARE,
  MAPS,
  TRACE,
} from 'src/app/shared/routeLink.constant';
import { MessageModule } from 'primeng/message';
import { DashPipe } from 'src/app/shared/pipes/dash.pipe';
import { HttpService } from 'src/app/core/services/http.service';
import * as ENDPOINT from 'src/app/shared/api.constant';
import { lob, allVariants } from '../../tracking.config';
import { UtilService } from 'src/app/core/services/util.service';
import { COMMON_SVG_IMG_PATH } from 'src/app/shared/common.constant';
import { Store } from '@ngrx/store';
import { selectSelectedVehicle } from 'src/app/store/user/user.selectors';
import { DateTimePipe } from 'src/app/shared/pipes/date-time.pipe';
import { LocationComponent } from 'src/app/shared/component/location/location.component';
import { VehicleColorConfigService } from 'src/app/shared/service/vehicle-color-config.service';

@Component({
  selector: 'app-vehicle-tracking-live',
  templateUrl: './vehicle-tracking-live.component.html',
  styleUrls: ['./vehicle-tracking-live.component.scss'],
  standalone: true,
  imports: [
    SpinnerComponent,
    CommonModule,
    PrimecustomModule,
    MapTypeViewComponent,
    MessageModule,
    DashPipe,
    DateTimePipe,
  ],
})
export class VehicleTrackingLiveComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  vehicleKey = '';
  selectedVehicle: any;
  vehicleNumber = ''; //selected vehicle on map
  vehicleDisplayNumber = '';

  messages!: ToastMessageOptions[];
  map!: any;
  mapOptions: google.maps.MapOptions = MAP_CONFIG.mapOptions;
  mapsApiLoaded!: boolean;
  mapCenter!: LatLngLiteral;
  private readonly googleMapsService = inject(GoogleMapsService);
  vehicleInfo: VehicleInfo[] = [];
  vehicleFromResp: VehicleInfo[] = [];
  vehicleTypeCode = '';
  lob: any = lob;
  expirationTime: Date = new Date();
  status = '';
  model = '';
  reportingTime: any = new Date();
  private subscription!: Subscription;
  timeLeft: { days: string; hours: string; minutes: string; seconds: string } =
    {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
    };
  markerCluster: any;
  markerReference: any = [];
  polylineReference: any = [];
  polyPath!: any;
  showRefreshButton = false; // Show refresh button on error
  svgPath = COMMON_SVG_IMG_PATH;
  polyLines: any = [];
  isLoggedIn = false;

  markers: google.maps.marker.AdvancedMarkerElement[] = [];
  currentInfoWindow: google.maps.InfoWindow | null = null;
  startMarker: google.maps.Marker | null = null;
  infoWindowdata: {
    soc: number;
    odometer: number;
    vehicle_code: string;
    vehicle_number: string;
    speed: number;
    geo_lat: number;
    geo_long: number;
    status: string;
    unit: string;
    last_updated_time?: any;
    coordinates: any;
    vehicleTypeCode?: string;
    hourmeter?: any;
    variantCode?: string;
  } = {
    soc: 0,
    odometer: 0,
    vehicle_code: '-',
    vehicle_number: '-',
    speed: 0,
    geo_lat: 0,
    geo_long: 0,
    status: '-',
    unit: '-',
    coordinates: {
      latitude: 0,
      longitude: 0,
    },
    hourmeter: 0,
    variantCode: '',
  };
  isError = false;
  isLoaded = false;
  unsubscribe$ = new Subject<void>();
  plotResponse: any;
  selectedVehicleToTitlecase = '';
  private mapReady = false;
  private pendingPlot = false;
  trafficLive = true;

  @Input() popupAccess = false;
  @Input() popupVehicleCode: any = '';
  constructor(
    private readonly zone: NgZone,
    public loadingService: LoadingService,
    private readonly sso: SsoService,
    private readonly activeRoute: ActivatedRoute,
    private readonly commonService: CommonService,
    private readonly sseService: ServerEventService,
    private readonly route: Router,
    private readonly AuthenticationService: AuthenticationService,
    private readonly sharedServices: HttpService,
    private readonly utils: UtilService,
    private readonly store: Store,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
    private readonly batteryColorService: VehicleColorConfigService,
    private readonly common: CommonService
  ) {}
  ngOnInit(): void {
    this.getSvgPath();

    this.store.select(selectSelectedVehicle).subscribe((vehicle) => {
      this.selectedVehicle = vehicle;
    });

    this.selectedVehicle = this.selectedVehicle?.name ?? 'Truck';
    this.selectedVehicleToTitlecase = this.selectedVehicle;
    this.selectedVehicle = this.selectedVehicle.toLowerCase();
    this.mapCenter = this.googleMapsService.getCurrentPosition();
    this.activeRoute.paramMap.subscribe((params) => {
      this.vehicleKey = params.get('vehicleTrackerKey') ?? '';
      this.vehicleNumber = params.get('vehicleNumber') ?? '';
      this.vehicleDisplayNumber = params.get('vehicleNumber') ?? '';
    });
    if (!this.vehicleKey) {
      this.vehicleNumber = history.state.vehicle;
      this.vehicleDisplayNumber = history.state.regNum;

      if (this.popupAccess) {
        this.vehicleNumber = this.popupVehicleCode;
        this.vehicleDisplayNumber = this.popupVehicleCode;
      }
    }

    this.AuthenticationService.currentAuthStatus.subscribe((user) => {
      if (user) {
        this.isLoggedIn = true;
      } else {
        this.isLoggedIn = false;
      }
    });
    this.isError = false;

    if (this.vehicleKey) {
      this.loadVehicles();
    } else {
      this.loadVehiclesInternal();
    }

    // Handle errors
    this.sseService.error$.subscribe((error: string) => {
      this.showRefreshButton = true; // Show refresh button on error
      this.sseService.closeEventSource();
      this.loadingService.hide();
    });
  }
  getSvgPath() {
    this.svgPath = this.commonService.getSelectedLobPath();
  }
  loadVehicles() {
    this.loadingService.show();
    this.sso.getSSEURL(live_tracking + '/' + this.vehicleKey).subscribe({
      next: (ele: LiveShare) => {
        this.isLoaded = true;
        if (ele.status) {
          const res = ele.data.response;
          this.vehicleFromResp = res.vehicleInfo;
          this.vehicleInfo = res.vehicleInfo.filter(
            (e: any) => e.regNum == this.vehicleNumber
          );
          this.vehicleTypeCode = res.vehicleTypeCode;
          this.expirationTime = res.expiryTime;
          this.reportingTime = res.createdTime;
          this.startCountdown();
          this.plotOnMap();
          this.isError = false;
        } else {
          this.reset(ele.data.message);
        }
        this.loadingService.hide();
      },
      error: (error: HttpErrorResponse) => {
        this.loadingService.hide();
        this.isLoaded = true;
      },
    });
  }

  reset(message: string) {
    this.vehicleNumber = '';
    this.status = '';
    this.model = '';
    this.reportingTime = '';
    this.messages = [{ severity: 'warn', summary: message }];
    this.isError = true;
  }

  loadVehiclesInternal() {
    if (this.vehicleNumber) {
      this.loadingService.show();
      const params = {
        regionCode: '',
        dealerCode: '',
        customerCode: '',
        fleetCode: '',
        vehicleCode: this.vehicleNumber || '',
        cityCode: '',
        stateCode: '',
        status: 'All',
      };

      this.sharedServices
        .get(ENDPOINT.PLOT_ON_MAP, { params: params })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (ele: any) => {
            this.isLoaded = true;
            if (ele.status) {
              this.plotResponse = ele.data.response[0];
              const res = ele.data.response.map((ele: any) => {
                return {
                  regNum: ele.vehicleNumber,
                  lat: ele.latitude,
                  lon: ele.longitude,
                  modelCode: ele.modelCode,
                };
              });
              const filterOneVehicle = res.length ? [res[0]] : [];
              this.vehicleFromResp = filterOneVehicle;

              this.vehicleInfo = filterOneVehicle;

              this.plotOnMap();
            }
            this.loadingService.hide();
            this.isError = false;
          },
          error: (error: HttpErrorResponse) => {
            this.loadingService.hide();
            this.isLoaded = true;
            if (!error.error?.status) {
              this.vehicleNumber = '';
              this.status = '';
              this.model = '';
              this.reportingTime = '';
              this.messages = [
                { severity: 'warn', summary: error.error?.data?.message },
              ];
              this.isError = true;
            }
          },
        });
    } else {
      this.route.navigateByUrl(`${TRACE}/${MAPS}`);
    }
  }

  ngAfterViewInit(): void {
    this.zone.runOutsideAngular(() => {
      this.googleMapsService
        .loadAPI()
        .then(async () => {
          await google.maps.importLibrary('marker');
          this.mapsApiLoaded = true;
          this.loadMap();
        })
        .catch(() => {
          this.mapsApiLoaded = false;
        });
    });
  }

  loadMap() {
    const zoomControlOptions = {
      position: google.maps.ControlPosition.TOP_RIGHT,
    };

    this.mapOptions = { ...this.mapOptions, zoomControlOptions, zoom: 15 };
    this.map = new google.maps.Map(
      document.getElementById('live-map') as HTMLElement,
      this.mapOptions
    );
    console.log(this.map, this.mapOptions);

    // const trafficLayer = new google.maps.TrafficLayer();
    // trafficLayer.setMap(this.map);
    this.mapReady = true;

    if (this.pendingPlot) {
      this.pendingPlot = false;
      this.plotOnMap();
    }
  }
  plotOnMap(): void {
    if (!this.map) {
      this.pendingPlot = true;
      return;
    }
    this.removeAllMarkers();
    const latLngBounds = new google.maps.LatLngBounds();

    if (this.vehicleInfo) {
      const BATCH_SIZE = 500; // Adjust batch size to balance performance
      const processBatch = (start: number) => {
        const batch = this.vehicleInfo.slice(start, start + BATCH_SIZE);

        batch.forEach((element) => {
          const latLng = {
            lat: element.lat,
            lng: element.lon,
          };

          // Get the marker icon
          const markerImage = this.getMarkerIcon(element);

          // Create an AdvancedMarkerElement without rendering to the map immediately
          const marker = new google.maps.marker.AdvancedMarkerElement({
            position: latLng,
            title: element.regNum,
            content: this.createMarkerContent(markerImage), // Custom marker content
          });

          // Push markers to the array but don't add to the map directly
          this.markers.push(marker);
          latLngBounds.extend(latLng);
          marker.addListener('click', () => {
            this.updateInfoWindow(element.regNum);
          });
        });

        // Process the next batch if available
        if (start + BATCH_SIZE < this.vehicleInfo.length) {
          setTimeout(() => processBatch(start + BATCH_SIZE), 0); // Yield control back to the browser
        } else {
          this.markerCluster = this.createMarkerClustering(
            this.map,
            this.markers
          );
          // this.map.fitBounds(latLngBounds);
          const vehicle = this.vehicleInfo[0];

          if (vehicle) {
            this.map.setCenter({
              lat: vehicle.lat,
              lng: vehicle.lon,
            });

            this.map.setZoom(15); // adjust as needed
          }
          this.loadingService.hide();
          // SSE must start only after markers exist — otherwise handleSocketData finds no marker
          if (this.vehicleKey) {
            this.loadSSE();
          } else {
            this.loadSSEInternalUsers();
          }
        }
      };
      processBatch(0);
    }
  }

  updateInfoWindow(regNum?: any) {
    if (this.currentInfoWindow) {
      this.currentInfoWindow.close(); // Close the current info window if it exists
    }
    const marker = this.markers.find((ele) => ele.title == regNum);
    const infowindow = this.createInfoWindow(this.infoWindowdata);
    infowindow.open(this.map, marker);
    this.currentInfoWindow = infowindow;
  }
  polyLine: any;
  plotPolylineOnMap(markers: any) {
    this.polyLine = new google.maps.Polyline({
      path: markers,
      geodesic: true,
      icons: [
        {
          icon: {
            path: 'M 0,-1 0,1',
            strokeColor: 'white',
            strokeOpacity: 1,
            strokeWeight: 5,
          },
          offset: '0',
          repeat: '10px',
        },
        {
          icon: {
            path: 'M 0,-1 0,1',
            strokeColor: '#0892D0',
            strokeOpacity: 1,
            strokeWeight: 5,
          },
          offset: '0',
          repeat: '20px',
        },
      ],

      // strokeColor: '#0892D0', // Custom color
      // strokeOpacity: 1.0,
      // strokeWeight: 5, // Thickness
    });
    this.polyLine.setMap(this.map);
    this.polylineReference.push(this.polyLine);
    if (!this.startMarker) {
      this.startMarker = new google.maps.Marker({
        position: this.polyLines[0], // First coordinate in the polylinePath array
        map: this.map,
        title: 'Starting Point', // Tooltip text
        icon: {
          url: this.getStartIcon(), // Replace with your image URL
          scaledSize: new google.maps.Size(50, 50), // Adjust the size of the image
        },
      });
    }
  }
  removeAllPolyLine() {
    this.polylineReference.forEach((marker: any) => {
      marker.setMap(null);
    });
    this.polylineReference = [];
    this.polyLine = null;
  }
  removeAllMarkers() {
    // Iterate over the markers array and remove each marker from the map
    this.markerReference.forEach((marker: any) => {
      marker.setMap(null);
    });
    this.markerReference = [];
    if (this.polyPath) {
      this.polyPath.setMap(null);
    }
    if (this.markerCluster) {
      this.markerCluster.clearMarkers(); // Clear previous clusters
    }
  }

  getMarkerIcon(element: any): string {
    const vehicleName = this.lob
      .find((ele: any) => ele.code == this.vehicleTypeCode)
      ?.name?.toLowerCase();
    const modelPart =
      element.variantCode && allVariants?.includes(element.variantCode)
        ? `${element.variantCode}/`
        : '';

    return `assets/img/${this.vehicleKey ? vehicleName : this.selectedVehicle}/${modelPart}playback.svg`;
  }

  getVehicleTypeName(): string {
    const type = this.lob.find((ele: any) => ele.code == this.vehicleTypeCode);
    return type?.name ?? 'Truck';
  }

  getStartIcon(): string {
    return 'assets/img/common/start-pin.svg';
  }

  createMarkerClustering(
    map: google.maps.Map,
    markers: google.maps.marker.AdvancedMarkerElement[]
  ): MarkerClusterer {
    return new MarkerClusterer({
      map,
      markers,
    });
  }
  createMarkerContent(
    markerImage: string,
    index?: number,
    size?: number
  ): HTMLElement {
    if (size) {
      const img = document.createElement('img');
      img.src = markerImage;
      img.style.cssText =
        index == 0 || index == size - 1
          ? 'width:40px;height:50px'
          : 'width:11px;height:11px';

      return img;
    } else {
      const img = document.createElement('img');
      img.src = markerImage;
      img.style.width = '40px';
      img.style.cssText =
        'display: flex; justify-content: center; align-items: center; flex-shrink:0;position: relative;bottom: -26px;width : 80px;height : 50px; ';
      return img;
    }
  }

  createInfoWindow(data: any) {
    const infoWindow = new google.maps.InfoWindow({
      content: this.infoWindowTemplate({
        ...data,
        address: 'Loading address...',
      }),
      ariaLabel: data.vehicle_code,
      minWidth: 220,
    });

    // Fetch address and update content later
    // MAP_CONFIG.getAddress(data.geo_lat, data.geo_long).then(
    //   (address: string) => {
    //     const updatedContent = this.infoWindowTemplate({
    //       ...data,
    //       address,
    //     });

    //     infoWindow.setContent(updatedContent);
    //   }
    // );

    const updatedContent = this.infoWindowTemplate({
      ...data,
      address: 'latlng',
    });

    infoWindow.setContent(updatedContent);

    return infoWindow;
  }

  infoWindowTemplate(
    data: any,
    infoWindowRef?: google.maps.InfoWindow,
    map?: google.maps.Map
  ): string {
    // Use the existing config logic
    const vehicleTypeName = this.getVehicleTypeName();
    const vehicleStatusAndColor = MAP_CONFIG.statusColor(data.status);
    const batteryColor = this.batteryColorService.batteryPercentColor(
      data.soc,
      vehicleTypeName
    );

    const contentString = MAP_CONFIG.infoWindow(
      vehicleStatusAndColor,
      data,
      batteryColor
    );

    if (infoWindowRef && map) {
      infoWindowRef.setContent(contentString);
      infoWindowRef.open(map);
    }

    // Optional enhancement: inject <app-location> if coordinates exist
    if (data?.coordinates) {
      requestAnimationFrame(() => {
        const container = document.getElementById('appLocationContainer');
        if (container && container.childElementCount === 0) {
          const factory =
            this.componentFactoryResolver.resolveComponentFactory(
              LocationComponent
            );
          const componentRef = factory.create(this.injector);
          componentRef.instance.coordinates = data.coordinates;
          componentRef.instance.disableTooltip = true;
          this.appRef.attachView(componentRef.hostView);
          container.appendChild((componentRef.hostView as any).rootNodes[0]);
        }
      });
    }

    return contentString;
  }

  private startCountdown(): void {
    this.subscription = interval(1000).subscribe(() => {
      this.calculateTimeLeft();
    });
  }

  private calculateTimeLeft(): void {
    const now = new Date().getTime();
    const expiry = new Date(this.expirationTime).getTime();
    const difference = expiry - now;

    if (difference <= 0) {
      this.subscription.unsubscribe();
      this.timeLeft = { days: '00', hours: '00', minutes: '00', seconds: '00' };
    } else {
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      this.timeLeft = {
        days: this.formatNumber(days),
        hours: this.formatNumber(hours),
        minutes: this.formatNumber(minutes),
        seconds: this.formatNumber(seconds),
      };
    }
  }

  private formatNumber(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  loadSSE() {
    this.sseService.closeEventSource();
    this.showRefreshButton = false;
    if (this.vehicleNumber) {
      const url = `${SSE_events}/${this.vehicleKey}?vehicleNumber=${this.vehicleNumber}`;
      this.subscription = this.sseService.getSocketEvents(url).subscribe({
        next: (data) => {
          this.handleSocketData(data);
        },
        error: () => {
          //Non-empty
        },
      });
    }
  }

  loadSSEInternalUsers() {
    this.sseService.closeEventSource();
    this.showRefreshButton = false;

    if (this.vehicleNumber) {
      this.store.select(selectSelectedVehicle).subscribe((vehicle) => {
        this.vehicleTypeCode = vehicle?.code || '';
      });
      const url = `${SSE_events}?vehicleNumber=${this.vehicleNumber}`;
      this.subscription = this.sseService.getSocketEvents(url).subscribe({
        next: (data) => {
          this.handleSocketData(data);
        },
        error: () => {
          //Non-empty
        },
      });
    } else {
      this.sseService.closeEventSource();
    }
  }

  refresh() {
    const now = new Date().getTime();
    const expiry = new Date(this.expirationTime).getTime();
    const difference = expiry - now;
    if (this.vehicleKey) {
      if (difference <= 0) {
        this.subscription.unsubscribe();
        this.sseService.closeEventSource();
        this.ngOnInit();
      } else {
        this.showRefreshButton = false; // Hide button while refreshing
        this.loadSSE(); // Re-initialize SSE connection
      }
    } else {
      this.showRefreshButton = false; // Hide button while refreshing
      this.loadSSEInternalUsers(); // Re-initialize SSE connection
    }
  }

  private handleSocketData(data: string): void {
    const sseData = JSON.parse(data);
    const sseLocation: google.maps.LatLngLiteral = {
      lat: sseData.latitude,
      lng: sseData.longitude,
    };
    this.infoWindowdata = {
      ...this.infoWindowdata,
      soc: sseData?.soc,
      odometer: sseData?.odo,
      geo_lat: sseData?.latitude,
      geo_long: sseData?.longitude,
      speed: sseData?.speed,
      unit: this.plotResponse?.odometer?.unit,
      vehicle_code: sseData?.regNum,
      vehicle_number: sseData?.regNum,
      status: sseData?.status,
      last_updated_time: sseData?.lastUpdatedTime,
      coordinates: sseData?.coordinates,
      vehicleTypeCode: this.vehicleTypeCode || '',
      hourmeter: sseData?.hmtr,
      variantCode: sseData?.variantCode,
    };
    this.status = this.statusName(sseData?.sts);

    const markerIndex = this.markers.findIndex(
      (ele) => ele.title === sseData?.regNum
    );

    if (markerIndex !== -1) {
      const marker = this.markers[markerIndex];
      const currentPos =
        marker.position instanceof google.maps.LatLng
          ? marker.position.toJSON()
          : marker.position;

      if (currentPos) {
        this.smoothMoveAdvancedMarker(marker, currentPos, sseLocation, 2000); // Smooth move over 1 second
        this.polyLines.push(sseLocation);
      } else {
        marker.position = new google.maps.LatLng(
          sseLocation.lat,
          sseLocation.lng
        );
      }
      const infowindow = this.createInfoWindow(this.infoWindowdata);
      if (this.currentInfoWindow?.isOpen) {
        this.currentInfoWindow.close();
        infowindow.open(this.map, marker);
      }
      this.currentInfoWindow = infowindow;
      this.map.setCenter(sseLocation);
      this.plotPolylineOnMap(this.polyLines);
    }
  }
  private smoothMoveAdvancedMarker(
    marker: any,
    start: google.maps.LatLng | google.maps.LatLngLiteral,
    end: google.maps.LatLngLiteral,
    duration: number
  ): void {
    const startLatLng: google.maps.LatLngLiteral =
      start instanceof google.maps.LatLng ? start.toJSON() : start;

    // Small tolerance to avoid floating-point noise
    const EPSILON = 1e-6;

    // If start and end are effectively the same → do nothing
    if (
      Math.abs(startLatLng.lat - end.lat) < EPSILON &&
      Math.abs(startLatLng.lng - end.lng) < EPSILON
    ) {
      // keep the current rotation, don't animate
      return;
    }

    const startTime = performance.now();

    // Compute start heading
    const startHeading = this.calculateRotationAngle(startLatLng, end);

    // Compute end heading (only if positions differ)
    const endHeading = google.maps.geometry.spherical.computeHeading(
      new google.maps.LatLng(startLatLng.lat, startLatLng.lng),
      new google.maps.LatLng(end.lat, end.lng)
    );

    const animate = (currentTime: number) => {
      const elapsedTime = currentTime - startTime;
      const t = Math.min(elapsedTime / duration, 1); // normalize to [0..1]

      // Interpolate position
      const lat = startLatLng.lat + (end.lat - startLatLng.lat) * t;
      const lng = startLatLng.lng + (end.lng - startLatLng.lng) * t;
      marker.position = new google.maps.LatLng(lat, lng);

      // Interpolate heading (shortest direction)
      let angleDiff = endHeading - startHeading;
      if (angleDiff > 180) angleDiff -= 360;
      if (angleDiff < -180) angleDiff += 360;
      const currentHeading = startHeading + angleDiff * t;

      // Apply rotation to marker element
      if (marker.content instanceof HTMLElement) {
        marker.content.style.cssText = `
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        position: relative;
        bottom: -24px;
        transform: rotate(${currentHeading + 90}deg);
      `;
      }

      if (t < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }

  private calculateRotationAngle(
    start: google.maps.LatLngLiteral,
    end: google.maps.LatLngLiteral
  ): number {
    const p1 = new google.maps.LatLng(start.lat, start.lng);
    const p2 = new google.maps.LatLng(end.lat, end.lng);
    return google.maps.geometry.spherical.computeHeading(p1, p2);
  }

  statusName(sts: number) {
    let statusName = '';
    switch (sts) {
      case 1:
        statusName = 'Charging';
        break;
      case 2:
        statusName = 'Moving';
        break;
      case 3:
        statusName = 'Stop';
        break;
      case 4:
        statusName = 'Re-Gen';
        break;
      default:
        statusName = '-';
    }
    return statusName;
  }
  getStyles(status: string) {
    return {
      color: MAP_CONFIG.statusColor(status),
    };
  }

  back() {
    if (this.vehicleKey) {
      if (this.vehicleFromResp.length == 1) {
        this.route.navigateByUrl(`/`);
      } else {
        this.route.navigateByUrl(`${LIVE_SHARE}/${this.vehicleKey}`);
      }
    } else {
      this.utils.viewType$.subscribe((value) => {
        const type = value == MAPS ? MAPS : LISTS;
        this.route.navigateByUrl(`${TRACE}/${type}`);
      });
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.sseService.closeEventSource();
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.sseService.closeEventSource();
    }
  }
}
